// Custom GIF play/pause functionality
(function() {
    'use strict';

    function initGifControls() {
        const gifs = document.querySelectorAll('#page-content img[src*=".gif"]');

        gifs.forEach(function(gif) {
            // Skip if already initialized
            if (gif.hasAttribute('data-gif-initialized')) return;
            gif.setAttribute('data-gif-initialized', 'true');

            // Wait for image to load
            if (!gif.complete) {
                gif.addEventListener('load', function() {
                    createControl(gif);
                });
            } else {
                createControl(gif);
            }
        });
    }

    function createControl(gif) {
        // Store original image source
        const originalSrc = gif.src;

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        wrapper.style.display = 'inline-block';
        wrapper.style.width = '100%';

        // Wrap the gif
        gif.parentNode.insertBefore(wrapper, gif);
        wrapper.appendChild(gif);

        // Make gif relative for proper layering
        gif.style.position = 'relative';
        gif.style.display = 'block';
        gif.style.width = '100%';

        // Create canvas for static image
        const canvas = document.createElement('canvas');
        canvas.width = gif.naturalWidth;
        canvas.height = gif.naturalHeight;
        canvas.style.width = '100%';
        canvas.style.height = 'auto';
        canvas.style.display = 'none';
        canvas.style.position = 'relative';

        const ctx = canvas.getContext('2d');
        ctx.drawImage(gif, 0, 0);

        wrapper.appendChild(canvas);

        // Create play/pause button using same classes as embla carousel
        const button = document.createElement('button');
        button.className = 'gif__playpause btn btn-dark rounded-circle playing';
        button.type = 'button';
        button.setAttribute('aria-label', 'Pause animation: ' + (gif.alt || 'GIF'));
        button.setAttribute('title', 'Pause animation: ' + (gif.alt || 'GIF'));
        button.style.position = 'absolute';
        button.style.bottom = '10px';
        button.style.left = '10px';
        button.style.zIndex = '10';

        // Add Font Awesome icons
        button.innerHTML = '<span class="fa-solid fa-pause"></span><span class="fa-solid fa-play"></span>';

        let isPlaying = true;

        button.addEventListener('click', function() {
            isPlaying = !isPlaying;

            if (isPlaying) {
                // Show GIF, hide canvas
                gif.style.display = 'block';
                canvas.style.display = 'none';
                button.classList.add('playing');
                button.classList.remove('paused');
                button.setAttribute('aria-label', 'Pause animation: ' + (gif.alt || 'GIF'));
                button.setAttribute('title', 'Pause animation: ' + (gif.alt || 'GIF'));
            } else {
                // Hide GIF, show canvas
                gif.style.display = 'none';
                canvas.style.display = 'block';
                button.classList.add('paused');
                button.classList.remove('playing');
                button.setAttribute('aria-label', 'Play animation: ' + (gif.alt || 'GIF'));
                button.setAttribute('title', 'Play animation: ' + (gif.alt || 'GIF'));
            }
        });

        wrapper.appendChild(button);
    }

    // Initialize on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGifControls);
    } else {
        initGifControls();
    }
})();
